/* eslint-disable import/prefer-default-export */
import {
  IS_SHOW_CANCEL_ORDER_DIALOG,
  IS_SHOW_CANCEL_ORDER_DIALOG_ALERT,
  IS_SHOW_STAR_DIALOG,
  IS_SHOW_BLACKLIST_DIALOG,
  IS_SHOW_REPORT_ISSUE_DIALOG,
  IS_SHOW_BONUS_PRICE_DIALOG,
  IS_SHOW_EXTRA_MESSAGE_DIALOG,
  IS_SHOW_SMS_PHONE_DIALOG,
  IS_SHOW_SMS_VERIFY_DIALOG,
  IS_SENDING_SMS,
  IS_SHOW_SMS_VERIFY_LOADING_DIALOG,
  IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG,
  IS_SHOW_SIMPLE_MESSAGE_DIALOG,
  SET_SIMPLE_MESSAGE,
  IS_SHOW_AGREE_TO_RECEIVER_DIALOG,
} from '../constants';

export function setIsCancelOrderDialogOn() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_CANCEL_ORDER_DIALOG,
    });
}

export function setIsCancelOrderAlertOn() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_CANCEL_ORDER_DIALOG_ALERT,
    });
}

export function setIsShowStarDialog() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_STAR_DIALOG,
    });
}
export function setIsShowBlacklistDialog() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_BLACKLIST_DIALOG,
    });
}
export function setIsShowReportIssueDialog() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_REPORT_ISSUE_DIALOG,
    });
}
export function setIsShowBonusPriceDialog() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_BONUS_PRICE_DIALOG,
    });
}
export function setIsShowExtraMessageDialog() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_EXTRA_MESSAGE_DIALOG,
    });
}
export function setIsShowSMSPhoneDialog() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_SMS_PHONE_DIALOG,
    });
}
export function setIsShowSMSVerfiyDialog() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_SMS_VERIFY_DIALOG,
    });
}
export function setIsSendingSMS(payload) {
  return dispatch =>
    dispatch({
      type: IS_SENDING_SMS,
      payload,
    });
}
export function setIsShowSMSVerfiyLoadingDialog() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_SMS_VERIFY_LOADING_DIALOG,
    });
}
export function setIsShowSMSVerfiySuccessDialog(payload) {
  return dispatch =>
    dispatch({
      type: IS_SHOW_SMS_VERIFY_SUCCESS_DIALOG,
      payload,
    });
}
export function setIsShowSimpleMessageDialog(payload) {
  return dispatch =>
    dispatch({
      type: IS_SHOW_SIMPLE_MESSAGE_DIALOG,
      payload,
    });
}
export function setSimpleMessage(payload) {
  return dispatch =>
    dispatch({
      type: SET_SIMPLE_MESSAGE,
      payload,
    });
}
export function setIsShowAgreeToReceiveDialog() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_AGREE_TO_RECEIVER_DIALOG,
    });
}



// WEBPACK FOOTER //
// ./src/actions/dialog.js